<template>
  <v-navigation-drawer
      class="mt-12 pb-7 nav-drawer" :mini-variant-width="$vuetify.breakpoint.mobile ? 0 : 56"
      app
      v-model="drawer"
      :mini-variant.sync="mini"
      permanent
      :expand-on-hover="!$vuetify.breakpoint.mobile"
  >
    <perfect-scrollbar>
      <v-list>
        <v-list-item
            dense
            color="#3A3852"
            class="item_menu"
            to="/"
        >
          <v-list-item-icon :class="`color-${menuItems.overview}`">
            <v-icon :class="`mr-3 fal fa-chart-line`"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="'Overview'"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item
            v-if="user[0].can('see_analytics_section') || user[0].can('reports_affiliates_POV') || user[0].can('reports_advertisers_POV') || user[0].can('reports_both_POV')"
            dense
            color="#3A3852"
            class="item_menu"
            style="cursor: default;"
        >
          <v-list-item-icon :class="`color-${menuItems.analytics}`">
            <v-icon :class="`mr-3 fal fa-analytics`"></v-icon>
            <span class="nav-line"></span>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-italic" v-text="'Analytics'"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item-group v-if="user[0].can('see_analytics_section') || user[0].can('reports_affiliates_POV') || user[0].can('reports_advertisers_POV') || user[0].can('reports_both_POV')">
          <span class="nav-group-line"></span>
          <v-list-item
              dense
              color="#3A3852"
              class="item_menu"
              :class="{disabled_color : item.disabled}"
              :disabled="item.disabled"
              v-for="(item) in analyticsItems"
              :key="item.url"
              :to="item.url"
          >
            <v-list-item-content class="with-line">
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
        <v-list-item
            v-if="user[0].can('see_affiliates_section')"
            dense
            color="#3A3852"
            class="item_menu"
            style="cursor: default;"
        >
          <v-list-item-icon :class="`color-${menuItems.affiliates}`">
            <v-icon class="mr-3 fal fa-user-friends"></v-icon>
            <span class="nav-line"></span>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-italic" v-text="'Affiliates'"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item-group v-if="user[0].can('see_affiliates_section')">
          <span class="nav-group-line"></span>
          <v-list-item
              dense
              color="#3A3852"
              class="item_menu"
              :class="{disabled_color : item.disabled}"
              :disabled="item.disabled"
              v-for="(item) in affiliatesItems"
              :key="item.url"
              :to="item.url"
              @click="setPageTitle(item.title)"
          >
            <v-list-item-content class="with-line">
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
            <i class="logo" v-if="item.text === 'Workflow'"></i>
          </v-list-item>
        </v-list-item-group>
        <v-list-item
            v-if="user[0].can('see_advertisers_section')"
            dense
            color="#3A3852"
            class="item_menu"
            style="cursor: default;"
        >
          <v-list-item-icon :class="`color-${menuItems.advertisers}`">
            <v-icon class="mr-3 fal fa-ad"></v-icon>
            <span class="nav-line"></span>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-italic" v-text="'Advertisers'"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item-group v-if="user[0].can('see_advertisers_section')">
          <span class="nav-group-line"></span>
          <v-list-item
              dense
              color="#3A3852"
              class="item_menu"
              :class="{disabled_color : item.disabled}"
              :disabled="item.disabled"
              v-for="(item) in advertisersItems"
              :key="item.url"
              :to="item.url"
              @click="setPageTitle(item.title)"
          >
            <v-list-item-content class="with-line">
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
        <v-list-item
            v-if="user[0].can('see_finance_section')"
            dense
            color="#3A3852"
            class="item_menu"
            to="/finance"
        >
          <v-list-item-icon :class="`color-${menuItems.finance}`">
            <v-icon class="mr-3 fal fa-money-bill-wave"></v-icon>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title v-text="'Finance'"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>
        <v-list-item-group v-if="user[0].can('see_finance_section')">
          <span class="nav-group-line"></span>
          <v-list-item
              dense
              color="#3A3852"
              class="item_menu"
              v-for="(item) in financeItems"
              :key="item.url"
              :to="item.url"
              :class="{disabled_color : item.disabled}"
              :disabled="item.disabled"
              @click="setPageTitle(item.title)"
          >
            <v-list-item-content class="with-line">
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>
        <v-list-item
            v-if="user[0].can('manage_account_managers')"
            dense
            color="#3A3852"
            class="item_menu"
            style="cursor: default;"
        >
          <v-list-item-icon :class="`color-${menuItems.employees}`">
            <v-icon class="mr-3 fal fa-clipboard-user"></v-icon>
            <span class="nav-line"></span>
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-italic" v-text="'Employees'"></v-list-item-title>
          </v-list-item-content>
        </v-list-item>

        <v-list-item-group v-if="user[0].can('manage_account_managers')">
          <span class="nav-group-line"></span>
          <v-list-item
              dense
              color="#3A3852"
              class="item_menu"
              v-for="(item) in employeesItems"
              :key="item.url"
              :to="item.url"
              @click="setPageTitle(item.title)"
          >
            <v-list-item-content class="with-line">
              <v-list-item-title v-text="item.text"></v-list-item-title>
            </v-list-item-content>
          </v-list-item>
        </v-list-item-group>

      </v-list>
    </perfect-scrollbar>
  </v-navigation-drawer>
</template>

<script>
import store from "@/store";
import {mapState} from "vuex";
import affiliates from "@/api/affiliates";
import {devs, sales} from "@/constants";

export default {
  props: ['value'],
  name: "Navigation",
  data() {
    return {
      mini: true,
      platform: null,
      drawer: false,
      tempColor: 'secondary',
      overviewColor: this.$vuetify.theme.themes.light.secondary,
      analyticsItems: [
        {text: 'Reports', url: '/analytics/reports'},
        {text: 'Reports V2', url: '/analytics/reportsV2'},
        {text: 'Reports V3 duckDB', url: '/analytics/reportsV3'},
        {text: 'Reports V4 clickHouse', url: '/analytics/reportsV4'},
        {text: 'Assistance (Beta)', url: '/analytics/rag'},

        // {text: 'Hitmaps', url: '/analytics/hitmaps', disabled: true},
        // {text: 'Insights', url: '/analytics/insights'},
      ],
      affiliatesItems: [
        { text: 'Profiles', url: '/affiliates/profiles', title: 'Affiliate Profiles' },
        { text: 'Campaigns', url: '/affiliates/campaigns', title: 'Affiliate Campaigns' },
        { text: 'Mass Manage Affiliate PID', url: '/affiliates/massManageAffiliatePID', title: 'Mass Manage Affiliate PID' },
        { text: 'Mass campaigns', url: '/affiliates/multipleCampaignsCreation/1', title: 'Mass campaigns' },
        { text: 'Custom assets', url: '/affiliates/customAssets', disabled: true, title: 'Custom Assets' },
        { text: 'Dashboard Alerts', url: '/affiliates/alerts', title: 'Affiliate Alerts' },
        { text: 'Dashboard News', url: '/affiliates/news', title: 'Affiliate News' },
      ],
      advertisersItems: [
        { text: 'Profiles', url: '/advertisers/profiles', title: 'Advertiser Profiles' },
        { text: 'Offers', url: '/advertisers/offers', title: 'Advertiser Offers', disabled: true },
        { text: 'Applications', url: '/advertisers/applications', title: 'Advertiser Applications', disabled: true },
        { text: 'Programs', url: '/advertisers/programs', title: 'Advertiser Programs', disabled: true },
        { text: 'Domains', url: '/advertisers/domains', title: 'Advertiser Domains', disabled: true },
        { text: 'Traffic Control', url: '/advertisers/blocking', title: 'Advertiser Traffic Control', disabled: true },
        { text: 'Pixel log', url: '/advertisers/pixelLog', title: 'Advertiser Pixel Log' },
      ],
      financeItems: [
        { text: 'Invoicing', url: '/finance/invoicing', title: 'Finance - Invoicing' }
      ],
      employeesItems: [
        { text: 'Account Managers', url: '/managers/accountManagers', title: 'Employees - Account Managers' }
      ]

    }
  },
  methods: {
    setPageTitle(title) {
      document.title = title;
    },
    menuIconColor(item) {
      const itemsMap = {
        analytics: 'analyticsItems',
        affiliates: 'affiliatesItems',
        advertisers: 'advertisersItems'
      };
      if(item === 'overview') {
        if(this.$route.path === '/') {
          return this.$vuetify.theme.themes.light.primary
        }
        else {
          return this.$vuetify.theme.themes.light.secondary
        }
      } else if(itemsMap[item] && this[itemsMap[item]]) {
        if (this[itemsMap[item]].find(menuItem => this.$route.path.includes(menuItem.url))) {
          return this.$vuetify.theme.themes.light.primary
        } else {
          return this.$vuetify.theme.themes.light.secondary
        }
      } else {
        if (this.$route.path.includes(item)) {
          return this.$vuetify.theme.themes.light.primary
        } else {
          return this.$vuetify.theme.themes.light.secondary
        }
      }
    },
  },
  computed: {
    ...mapState('user', ['user']),
    menuItems() {
      const menuItems = {
        analytics: 'secondary',
        affiliates: 'secondary',
        advertisers: 'secondary',
        overview: 'secondary',
        finance: 'secondary',
        employees: 'secondary',
      };
      this.analyticsItems.forEach((item) => {
        if (this.$route.path.includes(item.url)) {
          menuItems['analytics'] = 'primary';
        }
      });

      if (this.platform === 1) {
        this.affiliatesItems = this.affiliatesItems.filter(
          item => item.text !== 'Mass Manage Affiliate PID'
        );
      }
      this.affiliatesItems.forEach((item) => {
        if (this.$route.path.includes(item.url)) {
          menuItems['affiliates'] = 'primary';
        }
        if (item.text  === 'Custom assets'){
          // if (this.user[0].can('custom_assets_manage')){
            item.disabled = false
          // }
        }
      //   if ( this.platform === 1){
      //     if (item.text === 'Mass Manage Affiliate PID'){
      //       item.disabled = true
      //     }
      //   }
      });
      this.advertisersItems.forEach((item) => {
        if (this.$route.path.includes(item.url)) {
          menuItems['advertisers'] = 'primary';
        }

        if (item.text  === 'Domains'){
          if (this.user[0].can('see_domains_budget')){
            item.disabled = false
          }
        }
        if (item.text === 'Programs' && this.user[0].can('access_programs')){
          item.disabled = false
        }
        if (item.text === 'Applications' && this.user[0].can('review_application')){
          item.disabled = false
        }
        if (item.text === 'Traffic Control'
            && this.user[0].can('traffic_control_read')
            || this.user[0].can('traffic_control_manage')
        ){
          item.disabled = false
        }
        if (item.text  === 'Offers'){
          if (this.user[0].can('read_offers') || this.user[0].can('manage_offers') ){
            item.disabled = false
          }
        }
      });
      if (this.$route.path === '/') {
        menuItems['overview'] = 'primary';
      }
      if (this.$route.path.includes('/finance')) {
        menuItems['finance'] = 'primary';
      }

      return menuItems;
    }
  },
  async mounted() {
    this.platform = await affiliates.getPlatform();

    const fullAccess = devs;
    const advancedAccess = [...devs, ...sales];
    const username = this.user?.[0]?.name || '';

    this.analyticsItems = this.analyticsItems.filter(item => {
      if (this.platform !== 2) return !['Reports V3 duckDB', 'Reports V4 clickHouse', 'Assistance (Beta)'].includes(item.text);

      if (['Reports V3 duckDB', 'Reports V4 clickHouse'].includes(item.text)) {
        return advancedAccess.includes(username);
      }

      if (item.text === 'Assistance (Beta)') {
        return fullAccess.includes(username);
      }

      return true;
    });
  },

  watch: {
    value() {
      this.mini = this.value
    },
    mini() {
      this.$emit('input', this.mini)
    }
  },
}
</script>

<style scoped>

</style>
